import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=f72b48d4&scoped=true&"
import script from "./ProgressBar.vue?vue&type=script&lang=ts&"
export * from "./ProgressBar.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressBar.vue?vue&type=style&index=0&id=f72b48d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72b48d4",
  null
  
)

export default component.exports